import { Group, Modal, Space, Stack } from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";
import FormComponent, { FormInputTypes } from "../form/form.component";
import { emailValidator, requiredValidator } from "../form/validators.form";
import { toast } from "react-toastify";
import { loadLookups } from "../../helpers/lookup.helper";
import { submitAskForHelp } from "../../store/actions/form.actions";
import { PLButton } from "../common/button";
import { useMediaQuery } from "react-responsive";
import "./ask-help.component.scss";

const formSettings = [
  {
    name: "email",
    label: "Email *",
    placeholder: "Email",
    type: FormInputTypes.TEXT,
    validator: emailValidator,
  },
  {
    name: "subject",
    label: "Subject *",
    placeholder: "Subject",
    lookup: "LK_HELP_SUBJECTS",
    type: FormInputTypes.LOOKUP_SELECT,
    validator: requiredValidator,
  },
  {
    name: "message",
    label: "Message *",
    placeholder: "Message",
    type: FormInputTypes.TEXTAREA,
    validator: requiredValidator,
  },
];

export const AskHelp = ({
  buttonClassName,
}: {
  buttonClassName?: string;
}) => {
  const [opened, setOpened] = useState(false);

  const [lookups, setLookups] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const formRef = useRef(null);

  useEffect(() => {
    loadLookups(formSettings, {}, (data: Array<any>) => {
      setLookups(data);
    });
  }, []);

  const onsubmitHandler = async () => {
    setSubmitting(true);
    if (formRef.current) {
      const values = formRef.current.getFormValues();
      try {
        await submitAskForHelp(values);
        setOpened(false);
        toast.success("Your request has been submitted");
        setSubmitting(false);
      } catch (e) {
        console.error(e);
        toast.error("Failed to submit the form");
        setSubmitting(false);
      }
    }
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        withCloseButton={false}
        size="md"
        className="ask-help-modal"
      >
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h2 className="modal-title">ASK FOR HELP</h2>
            <button
              onClick={() => setOpened(false)}
              className="close-button"
            >
              ×
            </button>
          </div>

          {/* Description */}
          <p className="modal-description">
            Need assistance? Fill out the form below and our support team will get back to you as soon as possible.
          </p>

          {/* Form */}
          <FormComponent
            config={formSettings}
            lookups={lookups}
            ref={formRef}
          />

          {/* Buttons */}
          <div className="modal-buttons">
            <PLButton 
              variant="secondary" 
              size="lg"
              onClick={() => setOpened(false)}
              className="button-flex"
            >
              Cancel
            </PLButton>
            <PLButton 
              variant="blue" 
              size="lg"
              onClick={onsubmitHandler}
              disabled={submitting}
              className="button-flex"
            >
              {submitting ? "Sending..." : "Send"}
            </PLButton>
          </div>
        </div>
      </Modal>

      <PLButton
        variant="green"
        size="lg"
        onClick={() => setOpened(true)}
        ariaLabel="Open help form"
        className={buttonClassName}
      >
        Need Help?
      </PLButton>
    </>
  );
};
